<template>
  <div class="Pending">
    <OrderTable
      v-model="selection"
      :orders="pendingOrders"
      :color-by-type="true"
      :cols="[
        'Zone',
        'Account',
        'Type',
        'Order Notes',
        'Delivery Notes',
        'Address',
        'Qty',
        'Invoices',
        'Status',
      ]"
    />
    <OrderSelection v-model="selection">
      <template slot-scope="{ doAction }">
        <btn id="addToWaveForm" type="primary">Add to Wave</btn>
        <popover
          title="Add to wave"
          target="#addToWaveForm"
          v-model="addToWaveForm.show"
          placement="top"
        >
          <template slot="popover">
            <form @submit.prevent="doAction('Adding', addToWave)">
              <div>
                <label>Select a wave:</label>
                <br />
                <select v-model="addToWaveForm.selected">
                  <option v-for="wave in waves" :key="wave.id" :value="wave.id">
                    {{ getWaveDisplayName(wave) }}
                  </option>
                </select>
              </div>
              <div v-if="addToWaveForm.selected === waves[0].id">
                <label>Wave name:</label>
                <br />
                <input
                  type="text"
                  v-model="addToWaveForm.name"
                  placeholder="My Wave"
                  required
                />
                <br />
                <label>
                  <input type="checkbox" v-model="addToWaveForm.repSample" />
                  Has rep samples?
                </label>
                <br />
                <small class="text-muted"
                  >Excludes wave from sort by route reports</small
                >
              </div>
              <br />
              <div>
                <btn type="primary" native-type="submit">{{
                  addToWaveForm.selected === waves[0].id ? 'Create' : 'Add'
                }}</btn>
                <btn @click="addToWaveForm.show = !addToWaveForm.show"
                  >Cancel</btn
                >
              </div>
            </form>
          </template>
        </popover>
        <btn @click="doAction('Refreshing', refreshFromSidekick)" type="danger">
          Refresh data
        </btn>
      </template>
    </OrderSelection>
  </div>
</template>

<script>
import {
  getOrders,
  createWave,
  addOrdersToWave,
  refreshOrdersFromSidekick,
} from '@/queries';

import { formatGraphQLError } from '@/utils';

const NEW_WAVE = {
  id: '__NEW_WAVE__',
  name: '[Create new wave]',
};

export default {
  name: 'Approved',
  props: ['pickDate', 'orders'],
  data() {
    return {
      selection: [],
      addToWaveForm: {
        show: false,
        selected: NEW_WAVE.id,
        name: null,
        repSample: false,
      },
    };
  },
  computed: {
    pendingOrders() {
      return this.orders.filter(
        (order) =>
          order.qty > 0 &&
          order.status !== 'cancelled' &&
          order.status !== 'completed' &&
          order.wave === null
      );
    },
    waves() {
      let waves = this.orders.reduce((memo, order) => {
        if (order.wave && !order.wave.releasedAt && !memo[order.wave.id]) {
          memo[order.wave.id] = order.wave;
        }
        return memo;
      }, {});

      waves = Object.values(waves);
      waves.unshift(NEW_WAVE);

      return waves;
    },
  },
  methods: {
    getWaveDisplayName(wave) {
      let name = wave.name;
      if (wave.repSample) {
        name = '(s) ' + name;
      }
      return name;
    },
    async addToWave(orders) {
      this.addToWaveForm.show = false;

      let waveId;

      if (this.addToWaveForm.selected === NEW_WAVE.id) {
        try {
          const { data } = await this.$apollo.mutate({
            mutation: createWave,
            variables: {
              input: {
                name: this.addToWaveForm.name,
                pick_date: this.pickDate,
                repSample: this.addToWaveForm.repSample,
              },
            },
          });
          waveId = data.createWave.wave.id;
        } catch (e) {
          if (
            e.graphQLErrors &&
            e.graphQLErrors[0].extensions.exception &&
            e.graphQLErrors[0].extensions.exception.errno === 1062
          ) {
            throw new Error(
              `Duplicate name ${this.addToWaveForm.name} for today's date`
            );
          }
          throw formatGraphQLError(e);
        }
      } else {
        waveId = this.addToWaveForm.selected;
      }

      try {
        await this.$apollo.mutate({
          mutation: addOrdersToWave,
          variables: {
            input: {
              waveId,
              orderIds: orders.map((order) => order.id),
            },
          },
        });
      } catch (e) {
        throw formatGraphQLError(e);
      }

      this.addingToWave = false;
      this.addToWaveForm.selected = waveId;
      this.addToWaveForm.name = null;
      this.addToWaveForm.repSample = false;
    },
    async refreshFromSidekick(orders) {
      try {
        await this.$apollo.mutate({
          mutation: refreshOrdersFromSidekick,
          variables: {
            input: {
              ids: orders.map((order) => order.id),
            },
          },
        });
      } catch (e) {
        throw formatGraphQLError(e);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Pending.vue